<template>
  <v-container id="childIntro" fluid class="pa-0">
    <v-row class="pt-13">
      <v-col md="6" cols="12">
        <v-img :src="require('@/assets/child-intro-section-bg-img.jpg')" height="300" contain />
      </v-col>
      <v-col md="6" cols="12" class="text-center text-md-left" :class="[isMobile ? 'kid-intro-section-content-mobile' : 'kid-intro-section-content']">
        <div class="kid-intro-section-small-header mb-4">KIDS</div>
        <div class="heading-h1 mb-5">Up for a quest? We’re ready with rewards.</div>
        <div class="mb-5">Let’s face it — chores are the worst thing adults ever invented. Still, the boss wants ‘things’ done and we’ve got cool stuff with your name on it.</div>
        <div class="mb-5">Okay, but how do I get it? Easi! Log in to your Easi Club account to see your quests. Complete them and earn your points!</div>
        <div class="mb-5">And guess what? There’s no nagging. We’ll send friendly reminders, not your parents. You just rack up points, go nuts in our Easi Rewards Club portal and we’ll ship out your goods. Whoo!</div>
        <v-btn color="secondary" href="https://www.easiclub.com" target="_blank">Kids: Starts Easi Club</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: "ChildIntroSection",

    computed: {
      isMobile() {
        return this.$vuetify.breakpoint.mobile;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .kid-intro-section-small-header {
    font-family: "Lato", sans-serif;
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #544837;
  }

  .kid-intro-section-content {
    padding: 0% 10% 5% 0%;
  }

  .kid-intro-section-content-mobile {
    padding: 5% 2%;
  }
</style>



// WEBPACK FOOTER //
// src/components/LandingPage/ChildIntroSection.vue